import styled from 'styled-components';
import { horizontalSpace, verticalSpace } from '@doltech/utils/lib/css-style';
import * as React from 'react';
import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';
import { UserAvatar } from '@doltech/ui/lib/figma/User/UserAvatar/UserAvatar';
import { fromScreen } from '@doltech/core/lib/responsive/responsive.util';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';

const Container = styled.div`
  width: 100%;

  ${verticalSpace(16)};

  .user-avatar {
    width: max-content;
  }

  ${fromScreen(769)} {
    display: flex;
    align-items: center;
    ${verticalSpace(0)};
    ${horizontalSpace(16)};
  }
`;
const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  ${verticalSpace(4)};
`;

const LinkWrap = styled.a`
  .author-name {
    border-bottom: 1px solid transparent;

    &:hover {
      border-color: ${colorsV2.gray180};
      width: max-content;
    }
  }
`;

interface ElementAuthorBottomProps {
  name?: string;
  avatarUrl?: string;
  description?: string;
  authorUrl?: string;
  disabledAuthor?: boolean;
}

export const ElementAuthorBottom = (props: ElementAuthorBottomProps) => {
  const { name, avatarUrl, description, authorUrl, disabledAuthor } = props;

  return (
    <Container>
      <UserAvatar
        layout="default"
        userName={name}
        userAvatar={avatarUrl}
        size={100}
      />
      <TextWrapper>
        {disabledAuthor ? (
          <ResponsiveTypography.Paragraph className="author-name" variant="semi-bold/20-28" color="gray180">
            {name}
          </ResponsiveTypography.Paragraph>
        ) : (
          <LinkWrap className="author-link" rel="author" href={authorUrl}>
            <ResponsiveTypography.Paragraph className="author-name" variant="semi-bold/20-28" color="gray180">
              {name}
            </ResponsiveTypography.Paragraph>
          </LinkWrap>
        )}
        <ResponsiveTypography.Paragraph variant="regular/16-24" color="neutral180">
          {description}
        </ResponsiveTypography.Paragraph>
      </TextWrapper>
    </Container>
  );
};
